import { APP_SWITCHER_TARGET_ID, MENU_DOM_ID } from '../constants';
import { loadStatechart, t } from '../state';
const buildLabeledInput = ({ id, inputType, label, name, testId }) => {
    const inputWrap = document.createElement('div');
    const input = document.createElement('input');
    input.setAttribute('id', id);
    input.setAttribute('type', inputType);
    input.setAttribute('placeholder', label);
    input.setAttribute('name', name);
    input.dataset.testId = testId;
    const labelElem = document.createElement('label');
    labelElem.setAttribute('for', name);
    labelElem.textContent = label;
    inputWrap.appendChild(labelElem);
    inputWrap.appendChild(input);
    return inputWrap;
};
export const getLoginUi = (translations, options) => {
    const statechart = loadStatechart();
    const lt = (key) => t(key, translations);
    const wrapper = document.createElement('div');
    const targetId = options.targetId || APP_SWITCHER_TARGET_ID;
    wrapper.setAttribute('id', `${MENU_DOM_ID}_${targetId}`);
    wrapper.classList.add('app-switcher-login-form-wrap');
    const formTitle = document.createElement('h3');
    formTitle.classList.add('mas-form-title');
    formTitle.innerHTML = lt('app_switcher.login_form.form_title');
    const form = document.createElement('form');
    const usernameField = buildLabeledInput({
        testId: 'app-switcher-login-username',
        id: `app_switcher_login_username_${targetId}`,
        inputType: 'text',
        label: lt('app_switcher.login_form.username_field_label'),
        name: 'username'
    });
    const passwordField = buildLabeledInput({
        testId: 'app-switcher-login-password',
        id: `app_switcher_login_password_${targetId}`,
        inputType: 'password',
        label: lt('app_switcher.login_form.password_field_label'),
        name: 'password'
    });
    const submitButton = document.createElement('button');
    submitButton.classList.add('app-switcher-login-submit-btn');
    submitButton.setAttribute('type', 'submit');
    submitButton.innerHTML = lt('app_switcher.login_form.login');
    submitButton.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        statechart.sendEvent('loginClicked');
    });
    form.appendChild(usernameField);
    form.appendChild(passwordField);
    form.appendChild(submitButton);
    wrapper.appendChild(formTitle);
    wrapper.appendChild(form);
    return wrapper;
};
